module.exports = __webpack_public_path__ + "img/u1178.462742bd.png";